import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

type FileInput = { files: FileList; value: string };
type FileUploadEvent = { target: FileInput };

@Component({
  selector: 'app-custom-file-upload',
  templateUrl: './custom-file-upload.component.html',
  styleUrls: ['./custom-file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomFileUploadComponent {
  @Output() onClearFile = new EventEmitter<void>();
  @Output() onFileSelected = new EventEmitter<{ file: File }>();

  @ViewChild('fileInput') fileInput: ElementRef<FileInput>;

  get fileName(): string {
    return this.fileInput?.nativeElement.files.item(0)?.name;
  }

  constructor() {}

  onFileChanged(event: Event & FileUploadEvent): void {
    if (event.target.files.length) {
      this.onFileSelected.emit({ file: event.target.files.item(0) });
    }
  }

  clearFile(): void {
    this.fileInput.nativeElement.value = '';
    this.onFileSelected.emit({ file: undefined });
  }
}
